<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chicienski0007#pref">Preface</a></p>
<p class="toc"><a class="xref" href="#/chicienski0008#ch01"><b>1</b>  From People’s Poland to the Third Republic</a></p>
<p class="toc"><a class="xref" href="#/chicienski0009#ch02"><b>2</b>  In the Starting Blocks</a></p>
<p class="toc"><a class="xref" href="#/chicienski0010#ch03"><b>3</b>  Shocked by Therapy</a></p>
<p class="toc"><a class="xref" href="#/chicienski0011#ch04"><b>4</b>  The Survivors</a></p>
<p class="toc"><a class="xref" href="#/chicienski0012#ch05"><b>5</b>  Oligarchs?</a></p>
<p class="toc"><a class="xref" href="#/chicienski0013#ch06"><b>6</b>  White Socks and Dark Suits: The Polish Quest for Luxury</a></p>
<p class="toc"><a class="xref" href="#/chicienski0014#ch07"><b>7</b>  The Red Press Baron</a></p>
<p class="toc"><a class="xref" href="#/chicienski0015#ch08"><b>8</b>  On the Move</a></p>
<p class="toc"><a class="xref" href="#/chicienski0016#ch09"><b>9</b>  A Question of Scale</a></p>
<p class="toc"><a class="xref" href="#/chicienski0017#ch10"><b>10</b>  Crushed by Capitalism—or by the Visible Hand of the Government?</a></p>
<p class="toc"><a class="xref" href="#/chicienski0018#ch11"><b>11</b>  New Businesses</a></p>
<p class="toc"><a class="xref" href="#/chicienski0019#ch12"><b>12</b>  Halfway There</a></p>
<p class="tocbmf"><a class="xref" href="#/chicienski0020#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chicienski0021#ch13">Other Sources</a></p>
<p class="tocbm"><a class="xref" href="#/chicienski0022#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-cienski-0006.vue?38f053e6